export class AuditData {
    constructor(
        public remoteAddress: string,
        public sessionId: string
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/audits/audit-data.model.ts